import { WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import $ from 'jquery';
import { ParsedRequirementNode } from './requirementNodesProcessor';

export interface CredentialHandler {
	getCredentialTypeName(): string;
	getCredentialTypeMarkup(requirements: any): JQuery;
	isAutoPostCredential: boolean;
	getDataToAutoPost(
		_$form: JQuery,
		requirements: ParsedRequirementNode,
		config: WorkspaceConfiguration
	): void;
}

export const AuthExtensions = {
	CustomCredentialHandlers: [] as CredentialHandler[],
	AutoPostAllowed: true,
	AutoPostAdded: false,
	AutoPostButtonID: 'auto-post-btn',
	AutoPostCallback: $.noop as (form: JQuery) => void,

	getBaseCredentialHandler(): CredentialHandler {
		return {
			getCredentialTypeName: $.noop,
			getCredentialTypeMarkup(requirements) {
				return $('<div/>').addClass(requirements.credential.type);
			},
			isAutoPostCredential: false,
			getDataToAutoPost: $.noop,
		};
	},

	// Handler getters

	getCredentialHandlers() {
		return this.CustomCredentialHandlers;
	},

	getCredentialHandlerByType(credentialName: string) {
		const response = $.grep(this.CustomCredentialHandlers, function (handler) {
			return handler.getCredentialTypeName() === credentialName;
		}).shift();
		return response || null;
	},

	// Handler Setters

	addCustomCredentialHandler(credentialHandler: Partial<CredentialHandler>) {
		// Check if handler is for an auto post credential & add the isAutoPostCredential function as required.
		if (credentialHandler.getDataToAutoPost) {
			credentialHandler.isAutoPostCredential = true;
		}
		const mergedCredentialHandler = $.extend(
			{},
			this.getBaseCredentialHandler(),
			credentialHandler
		);
		this.CustomCredentialHandlers.push(mergedCredentialHandler);
	},

	// Inspection functions

	hasCustomCredential(credentialName: string) {
		if (this.getCredentialHandlerByType(credentialName)) {
			return true;
		}
		return false;
	},

	isAutoPostAllowed() {
		return this.AutoPostAllowed;
	},

	resetAutoPostChecks() {
		this.AutoPostAdded = false;
		this.AutoPostAllowed = true;
	},

	fieldAddedToForm() {
		this.AutoPostAllowed = false;
	},

	autoPostAddedToForm() {
		this.AutoPostAdded = true;
		this.AutoPostAllowed = false;
	},

	isAutoPostAddedToForm() {
		return this.AutoPostAdded;
	},

	// Auto-post helper functions

	registerAutoPostCallback(
		requirements: ParsedRequirementNode,
		callback: CredentialHandler['getDataToAutoPost'],
		workspaceConfiguration: WorkspaceConfiguration
	) {
		this.AutoPostCallback = function ($form) {
			callback($form, requirements, workspaceConfiguration);
		};
	},

	resetAutoPostCallback() {
		this.AutoPostCallback = $.noop;
	},

	// Note - this button currently doesn't send any information to the server.
	// If it did, the server ignores extra data it was expecting. So should be fine.
	getAutoPostButtonForForm() {
		return $('<a/>')
			.attr('id', this.AutoPostButtonID)
			.addClass('auto-post button forms-authentication-button');
	},

	autoPostForm() {
		const selectorString = '#' + this.AutoPostButtonID;
		$(selectorString).click();
	},

	getAutoPostInputField(requirements: any) {
		const id = requirements.credential.id;
		const $input = $('<input/>')
			.addClass(requirements.credential.type)
			.attr('id', id)
			.attr('name', id)
			.attr('type', 'hidden');
		return $input;
	},
};
